import { Flex, Tag } from "@chakra-ui/react";
import { ETH, LST_TAGS } from "@config/contractsConfig";
import useDappChain from "@hooks/useDappChain";
import useDappConfig from "@hooks/useDappConfig";
import usePageData from "@hooks/usePageData";
import { Row } from "@services/gsheets";
import { ComponentProps, FC } from "react";

type TokenTagsProps = ComponentProps<typeof Flex> & {
  token: string;
};

const TokenTags: FC<TokenTagsProps> = ({ token, ...props }) => {
  const { isEthereumChain } = useDappChain();
  const { config } = useDappConfig();

  const { availableTags, tokenTagMapping } = usePageData() as {
    availableTags: [
      string[],
      Row<{
        Tag: string;
        Color: string;
      }>[]
    ];
    tokenTagMapping: [
      string[],
      Row<{
        Token: string;
        Tags: string;
      }>[]
    ];
  };

  const tags = tokenTagMapping[1]
    .find((row) => row.Token === token)
    ?.Tags?.split(",")
    .map((tag) => tag.trim());

  if (!tags) return null;

  if (!isEthereumChain) {
    const isNative = token === ETH;
    const tokenConfig = isNative ? config.nativeToken : config.tokens[token];
    if (!tokenConfig) {
      return;
    }
    const extraTokens = tokenConfig.tags.filter(
      (t) => !tags.includes(LST_TAGS[t].title)
    );
    extraTokens.forEach((et) => {
      tags.push(LST_TAGS[et].title);
    });
  }

  const tagComponents = tags.map((tag) => {
    const tagData = availableTags[1].find((row) => row.Tag === tag);
    if (!tagData) return null;

    return (
      <Tag
        key={tag}
        bg={tagData.Color}
        color="white"
        fontSize="12px"
        fontWeight="400"
        letterSpacing="normal"
      >
        {tag}
      </Tag>
    );
  });

  return (
    <Flex gap={2} justifyContent="flex-end" flexWrap="wrap" {...props}>
      {tagComponents}
    </Flex>
  );
};

export default TokenTags;
